import React from 'react';
import { styled } from 'baseui';
import { Slider } from 'baseui/slider';
const SLIDER_HEIGHT = 280;
const SliderContainer = styled('div', ({
  $theme
}) => ({
  width: `${SLIDER_HEIGHT}px`,
  height: '44px',
  paddingTop: '8px',
  background: $theme.colors.contentInversePrimary,
  borderRadius: $theme.sizing.scale300,
  boxShadow: $theme.lighting.shadow600
}));
type HorizontalSliderPropsT = {
  min: number;
  max: number;
  value: number;
  onChange: (newValue: number) => void;
  onFinalChange?: (value: number) => void;
};
function HorizontalSlider({
  min,
  max,
  value,
  onChange,
  onFinalChange
}: HorizontalSliderPropsT) {
  return <SliderContainer data-testid="horizontal-slider">
      <Slider value={[value]}
    // @ts-expect-error todo(ts-migration) TS2345 Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
    onChange={({
      value
    }) => onChange(value[0])} onFinalChange={({
      value
    }) => {
      // @ts-expect-error todo(ts-migration) TS2345 Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
      onFinalChange && onFinalChange(value[0]);
    }} min={min} max={max} overrides={{
      InnerThumb: {
        style: ({
          $theme
        }) => ({
          display: 'none'
        })
      },
      ThumbValue: {
        style: ({
          $theme
        }) => ({
          display: 'none'
        })
      },
      TickBar: {
        style: ({
          $theme
        }) => ({
          display: 'none'
        })
      }
    }} />
    </SliderContainer>;
}
export default HorizontalSlider;